module.exports = __webpack_public_path__ + "img/barrage_prize_09.a5494346.png";